import { makeStyles } from '@material-ui/core';
import { createStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, MIDDLE_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      borderRadius: 10,
      padding: '24px 24px 24px 72px',
      display: 'flex',
      justifyContent: 'space-between',
      margin: '0 5px',
      flexDirection: 'column',
      background: colorsPalette.violetAnalyticsCard,
      position: 'relative',
      alignItems: 'flex-start',
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
        padding: `31px ${MIDDLE_MARGIN}px`,
        alignItems: 'center',
      },
    },
    leftBlock: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      marginBottom: 15,
      [theme.breakpoints.up('md')]: {
        marginRight: 45,
        marginBottom: 0,
      },
    },
    lockIcon: {
      width: 24,
      height: 24,
      position: 'absolute',
      top: 28,
      left: 26,
      [theme.breakpoints.up('md')]: {
        position: 'relative',
        marginRight: '25px',
        width: 43,
        height: 43,
        top: 'unset',
        left: 'unset',
      },
    },
    lockText: {
      fontSize: 20,
      marginBottom: 10,
      [theme.breakpoints.up('md')]: {
        fontSize: 26,
        marginRight: 48,
        marginBottom: 10,
        width: 105,
      },
    },
    description: {
      flex: 4,
      color: colorsPalette.gray,
      fontSize: 16,
      lineHeight: 1.35,
      marginBottom: 15,
      [theme.breakpoints.up('md')]: {
        textAlign: 'left',
        fontSize: 22,
        marginRight: 90,
        marginBottom: 0,
      },
    },
    link: {
      width: '100%',
      '& button': {
        width: '100%',
      },
      [theme.breakpoints.up('md')]: {
        width: 'auto',
      },
    },
  }),
);

export default useStyles;
